import axios from 'axios';

/**
 * Waitlist lives on **app-backend** (`packages/app-backend`), same service as `/live`.
 * Do not use `REACT_APP_API_URL` / `podscope-backend` — that is a different deploy and will 503.
 */
const APP_BACKEND_URL =
    process.env.REACT_APP_APP_BACKEND_URL?.replace(/\/$/, '') || 'http://localhost:3001';

/** Same copy as `packages/app-backend/src/routes/podscopeProfileWaitlist.ts` */
export const PODSCOPE_WAITLIST_YOUTUBE_URL_INVALID_MESSAGE =
    'El link debe ser una URL válida de YouTube (youtube.com o youtu.be).';

/** Mirrors backend `isAllowedYouTubeUrl` for client-side checks. */
export function isPodscopeWaitlistYouTubeUrlAllowed(raw: string): boolean {
    let parsed: URL;
    try {
        parsed = new URL(raw.trim());
    } catch {
        return false;
    }
    const host = parsed.hostname.toLowerCase().replace(/^www\./, '');
    if (host === 'youtu.be') return true;
    if (host === 'youtube.com' || host.endsWith('.youtube.com')) return true;
    return false;
}

export type PodscopeProfileWaitlistPayload = {
    name: string;
    email: string;
    cargo: string;
    youtubeChannelUrl: string;
};

export async function submitPodscopeProfileWaitlist(
    payload: PodscopeProfileWaitlistPayload
): Promise<{ ok: boolean; message?: string }> {
    const response = await axios.post<{ ok: boolean; message?: string }>(
        `${APP_BACKEND_URL}/api/public/podscope-profile-waitlist`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
}
